import { MapView } from 'cd-eft/utils/esriTypes';
import stores from 'cd-eft/models/Stores';
const AppStore = stores.AppStore;

export class MapPreferences {
  centerLat?: number;
  centerLong?: number;
  scale?: number;
  zoom?: number;
  layers: LayerPreferences[] = [];
}

export class LayerPreferences {
  id?: string;
  title?: string;
  type?: string;
  visible?: boolean;
}

export function exportMapPreferencesFromCurrentState(mapView: MapView): MapPreferences | undefined {
  if (mapView) {
    const mapPreferences: MapPreferences = new MapPreferences();

    const centerPoint = mapView.center;
    mapPreferences.centerLat = centerPoint.latitude;
    mapPreferences.centerLong = centerPoint.longitude;
    mapPreferences.scale = mapView.scale;
    mapPreferences.zoom = mapView.zoom;

    for (const layerView of mapView.allLayerViews) {
      const layerPreference = new LayerPreferences();
      layerPreference.id = layerView.layer.id;
      layerPreference.title = layerView.layer.title;
      layerPreference.type = layerView.layer.type;
      layerPreference.visible = layerView.layer.id !== 'result_flowpath_orig' ? layerView.layer.visible : false;

      mapPreferences.layers.push(layerPreference);
    }
    return mapPreferences;
  }
}

export function applyPreference_LayerVisibility(layers: any) {
  const userPreferences = AppStore.userProfileStore.getPreference('analysis-hydrology-project');
  if (userPreferences && userPreferences.layer_visibilities) {
    layers.forEach((layer) => {
      if (userPreferences.layer_visibilities[layer.title] !== undefined) {
        layer.visible = layer.id !== 'result_flowpath_orig' ? userPreferences.layer_visibilities[layer.title] : false;
      }
    });
  }
}
